import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"chase\" data-v-4b2c8277><div class=\"dot\" data-v-4b2c8277></div><div class=\"dot\" data-v-4b2c8277></div><div class=\"dot\" data-v-4b2c8277></div><div class=\"dot\" data-v-4b2c8277></div><div class=\"dot\" data-v-4b2c8277></div><div class=\"dot\" data-v-4b2c8277></div></div>", 1)),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
    })
  ]))
}